import globalComponents from './components';
import globalMethods from './global_methods';
import isIOS from './global_methods/ios';

export default {
  components: globalComponents,
  data() {
    return {
      iOS: isIOS(),
    };
  },
  computed: {
    userData() { return this.$store.state.userData; },
    userGroups() { return this.$store.state.userGroups; },
  },
  methods: globalMethods,
};
